export default __webpack_public_path__ + "images/slide_4.jpeg?cbd2c57e1e1b1ea8707d6eeadc404530";